module.exports = __webpack_public_path__ + "static/media/miniminus.b5b47c25.svg";